import { Loader } from 'semantic-ui-react';

function LoadingComponent() {
  return <Loader active />;
}

export default LoadingComponent;
